var map = {
	"./adult.png": 1699,
	"./circle-fill-heartbeat.png": 9476,
	"./covid.png": 4011,
	"./credit-card.png": 7931,
	"./danger.png": 3523,
	"./date.png": 9387,
	"./doc.png": 4967,
	"./doctor.png": 8553,
	"./door.png": 8372,
	"./health-list.png": 56,
	"./health-report.png": 448,
	"./hotel-receptionist.png": 95,
	"./information.png": 7555,
	"./key-room.png": 9862,
	"./kids.png": 5773,
	"./left-arrow.png": 6567,
	"./license.png": 3075,
	"./man-in-suit.png": 6684,
	"./martini.png": 8744,
	"./right-arrow.png": 2384,
	"./ruble-circle-underline.png": 4582,
	"./ruble.png": 9095,
	"./spa.png": 350,
	"./student-star-ribbon-shape.png": 2849,
	"./woman-call.png": 2169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;